import { Component, Input, OnChanges } from '@angular/core';


@Component({
  selector: 'app-import-error-file',
  templateUrl: './import-error-file.component.html',
  styleUrls: ['./import-error-file.component.css'],
  standalone: false
})

export class ImportErrorFileComponent implements OnChanges {
  columns: string[] = [];
  rows: any[] = [];
  headerErrors: string[] = [];

  @Input()
  title: string;

  @Input()
  data: any;

  private getDataList(): any[] {
    if (!this.data) return [];
    if (Array.isArray(this.data)) return this.data;
    if (this.data.$values && Array.isArray(this.data.$values)) return this.data.$values;
    return [];
  }

  ngOnChanges() {
    this.headerErrors = [];
    this.columns = [];
    this.rows = [];

    const dataList = this.getDataList();
    if (!dataList || dataList.length === 0) return;

    // Header-level error: Row is null, only Errors present
    const first = dataList[0];
    const row = first.Row ?? first.row;
    if (row === null || row === undefined) {
      const rawErrors = first.Errors ?? first.errors;
      const errors: any[] = Array.isArray(rawErrors) ? rawErrors : (rawErrors?.$values ?? []);
      this.headerErrors = errors.map((e: any) => this.getErrorMessage(e));
      return;
    }

    this.buildCleanRows();
    this.extractColumns();
  }

  extractColumns(): void {
    const dataList = this.getDataList();
    const firstItem = dataList.find((d: any) => (d.Row ?? d.row) != null);
    const firstRow = firstItem?.Row ?? firstItem?.row;
    if (!firstRow) return;
    this.columns = Object.keys(firstRow);
  }

  buildCleanRows(): void {
    const dataList = this.getDataList();
    this.rows = dataList
      .filter((item: any) => (item.Row ?? item.row) != null)
      .map((item: any) => item.Row ?? item.row);
  }

  /** Reads columnName from either casing: FileColumnError (lowercase c) or AzureFileColumnError (uppercase C) */
  private getErrorColumnName(e: any): string {
    return e.columnName ?? e.ColumnName ?? '';
  }

  /** Reads message from either casing */
  private getErrorMessage(e: any): string {
    return e.message ?? e.Message ?? '';
  }

  isColumnError(row: any, columnName: string): boolean {
    const rawErrors = row?.Errors ?? row?.errors;
    const errors: any[] = Array.isArray(rawErrors) ? rawErrors : (rawErrors?.$values ?? []);
    if (!errors || errors.length === 0) return false;
    return errors.some((e: any) => this.getErrorColumnName(e) === columnName);
  }

  getFormattedErrors(row: any): string {
    const rawErrors = row?.Errors ?? row?.errors;
    const errors: any[] = Array.isArray(rawErrors) ? rawErrors : (rawErrors?.$values ?? []);
    if (!errors || errors.length === 0) return '';
    return errors
      .map((e: any, index: number) => `${index + 1}- ${this.getErrorColumnName(e)} : ${this.getErrorMessage(e)}`)
      .join('<br>');
  }

}





